jQuery(document).ready(function($) {
		  
  var $navOffset = $('body').data('offset');
  
	// ##############################################
	// ################### To Top ###################
	// ##############################################  
  
	(function () {
  	var footer = $('body footer').get(0);
  	var top;
  	var scrollPos;
      var vh = $(window).outerHeight();
      $(window).resize(function () {
          vh = $(window).outerHeight();
      });
      var scrollToTop =  $('.scrollToTop');
  	
  	var relative = false;
  	var visible = false;
  	//var stickyNav = false;
  	
    $(window).scroll(function () {
      scrollPos = $(window).scrollTop();
      top = footer.getBoundingClientRect().top;
      
      if ((top < vh) != relative) {
        relative = top < vh;
        scrollToTop.toggleClass('relative', relative);
      }
      
      if (visible != (scrollPos > 250)) {
        visible = scrollPos > 250;
        scrollToTop.fadeToggle(visible);
      }
      
      //if (stickyNav != (scrollPos >= $offsetStickyNav)) {
      //  stickyNav = scrollPos >= $offsetStickyNav;
      //  $('body').toggleClass('sticky-nav', stickyNav);
      //}
        
    });  	
	}())
  
	$('.scrollToTop').click(function(){
		$('html, body').animate({scrollTop : 0}, 800);
		return false;
	});
  
  
  // ##############################################
  // ############### OffCanvas-Nav ################
  // ##############################################
    
  $('.menu-btn, .site-overlay').click(function(){
    $('.offcanvas-collapse').toggleClass('open');
    $('body').toggleClass('offcanvas-collapse-open');
  });
	$(window).resize(function() {
  	if ($(window).width() >= 992) {
      $('body').removeClass('offcanvas-collapse-open');
      $('.offcanvas-collapse').removeClass('open');
    }
  });
  
  
	// ##############################################
	// ################ Anchor-Link #################
	// ##############################################  
  
  $(".anchor-link").click(function(event) {
   event.preventDefault();
   if ($(this).closest('.nav-overlay').length) {
     //console.log('Ist in Mobile-Nav');
     $('body').removeClass('nav-open');
   }
   if ($(this.hash).offset()) {
     $('html,body').animate( { scrollTop:($(this.hash).offset().top - $navOffset)} , 800);
   }
  });	
  
  $(".slider-fullscreen-scroll a").click(function(event) {
   event.preventDefault();
   var parentSection = $(this).closest('section');
   var nextSection = parentSection.next('section');
   if ($(nextSection).length) {
     if ($(nextSection).offset()) {
       $('html,body').animate( { scrollTop:($(nextSection).offset().top - $navOffset)} , 800);
     }
   }
  });	
    
	// ##############################################
	// ################ Page Scroll #################
	// ##############################################

  var hash = window.location.hash;
  if (hash.length) {
    $('body, html').scrollTop(0);
    $('body').imagesLoaded(function() {
      if ($(hash).offset()) {
        setTimeout(function(){
          $('html,body').animate( { scrollTop:($(hash).offset().top - ($navOffset - 1))} , 800);
        }, 800);        
      }
    });
  }
  

});


// WEBPACK FOOTER //
// ./js/parts/header.js